import React, { useState } from 'react'
import Styles from '../EmailBlock.module.scss'
import { Button } from 'blaze-ui/Button/Button'
import { DateTimePicker } from 'blaze-ui/DateTimePicker/DateTimePicker'
import dayjs from 'dayjs'
import cx from 'classnames'

type SendTimeInputProps = {
  scheduledTime?: string
  onScheduledTimeChange: (time: string | null) => void
}

export function SendTimeInput({ scheduledTime, onScheduledTimeChange }: SendTimeInputProps) {
  const [localDate, setLocalDate] = useState<string | null>(null)

  const getButtonLabel = () => {
    if (scheduledTime) {
      return `Scheduled for ${dayjs(scheduledTime).format('MMM D, YYYY, h:mm A')}`
    }
    return 'Select a time to send'
  }

  let pickerDateTime
  if (localDate) {
    pickerDateTime = dayjs(localDate)
  } else if (scheduledTime) {
    pickerDateTime = dayjs(scheduledTime)
  } else {
    pickerDateTime = undefined
  }

  return (
    <div className={Styles.formGroup}>
      <label className={Styles.label} htmlFor="sendTime">
        Send Time
      </label>
      <div className={Styles.sendTimeContainer}>
        <DateTimePicker
          data-testid="send-time-picker"
          dateTime={pickerDateTime}
          setDateTime={(date) => {
            if (!date) return
            setLocalDate((date as dayjs.Dayjs).toISOString())
          }}
          allowPastDates={false}
          showTimeControls={true}
          popoverClassName={Styles.popover}
          actions={(close) => (
            <div className={Styles.actions}>
              {!!scheduledTime && (
                <Button
                  variant="primary"
                  onPress={() => {
                    if (localDate) {
                      onScheduledTimeChange(localDate)
                      setLocalDate(null)
                    }
                    close()
                  }}
                  data-testid="schedule-button"
                >
                  Update Send Time
                </Button>
              )}
              {!!scheduledTime && (
                <Button
                  variant="secondary"
                  onPress={() => {
                    onScheduledTimeChange(null)
                    setLocalDate(null)
                    close()
                  }}
                  data-testid="schedule-button"
                >
                  Unschedule
                </Button>
              )}
              {!scheduledTime && (
                <Button
                  variant="primary"
                  onPress={() => {
                    if (localDate) {
                      onScheduledTimeChange(localDate)
                      setLocalDate(null)
                    }
                    close()
                  }}
                  data-testid="schedule-button"
                >
                  Schedule
                </Button>
              )}
            </div>
          )}
        >
          <Button
            variant="secondary"
            withChevron="down"
            size="lg"
            fullWidth={true}
            className={cx(Styles.selectInput, Styles.scheduled)}
            data-testid="send-time-dropdown"
          >
            <span className={Styles.buttonText}>{getButtonLabel()}</span>
          </Button>
        </DateTimePicker>
      </div>
    </div>
  )
}
